import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../../../../services/toast.service';
import { ContratoTMA } from '../../../../../types/ContratoTMA.type';
import {ContratoService} from "../../../../../services/contrato.service";

interface Filtro {
  id: string;
  nome: string;
}


@Component({
  selector: 'app-tma',
  templateUrl: './tma.component.html',
  styleUrl: './tma.component.css',
  providers: [ConfirmationService]
})
export class TmaComponent {
  loading: boolean = false;
  taxas: ContratoTMA[] = []

  taxaSelecionada: ContratoTMA = {} as ContratoTMA

  visivel: boolean = false

  empresas: Filtro[] = []

  constructor(private contratoService: ContratoService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarTaxas();
  }

  carregarTaxas(){
    this.loading = true;
    this.taxas = [];
    this.contratoService.getTmas().subscribe({
      next: (data) => {
        this.taxas = data

        const deEmpresas = [...new Set(this.taxas.map(tm => tm.deEmpresa))];
        this.empresas = deEmpresas.map(empresa => ({id: empresa, nome: empresa}))
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreTmaDialog(taxa: ContratoTMA){
      this.visivel = true

      this.taxaSelecionada = taxa;
    }

  escondeTmaDialog(){
     this.visivel = false
     this.taxaSelecionada = {} as ContratoTMA

     this.carregarTaxas()
    }

  excluir(id: string){
    this.contratoService.deleteTma(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Provisão excluída com sucesso");
        this.carregarTaxas();
      },
      error: (value) => {
       this.toastService.erro("Erro", "Erro ao excluir: " + value)
      }
    })
  }

  confirmarExclusao(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza de que deseja excluir ?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.excluir(id);
      }
      });
  }

  exportar(){

    let corpo: any = {}

    this.contratoService.exportarParametros(corpo).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a')
      a.href = url
      a.download = 'data.xlsx'
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }
}
